import { deleteUsers } from '../api/deleteUsers';
import { setGetMailing } from './setGetMailing';
import { setGetMailingUsers } from './setGetMailingUsers';

export const setDeleteUsers = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await deleteUsers(params);
            alert('Удалено');

            dispatch(setGetMailingUsers({
                id: params.mailing_id,
                page: 1,
                pageSize: 25
            }));
        } catch (error) {
            alert(error?.response?.data?.message)
            console.log(error)
        }
    }
}